<img [src]="logoSrc()" alt="Logo" />
